/*
  Keyboard / screen-reader support for the collection page controls.

  - Sort dropdown: the open/close state is a hidden checkbox driven by a <label>
    (CSS-only). The label is given role="button" tabindex="0" in the markup; this
    script adds Enter/Space activation, Esc to close, and keeps aria-expanded in
    sync with the checkbox (which is also unchecked by other scripts).
  - Mobile "Filter" trigger (a.filter-button-label): keeps aria-expanded in sync
    with the open state of the filter sidebar, and adds Space activation.
  - Results announcer: filtering/sorting swaps the product grid via fetch()
    (custom-new-collection-filters.js) without a page load, so the new product
    count is written to the [data-collection-results-status] live region.
*/
(function () {
  'use strict';

  if (window.__collectionA11yInit) return;
  window.__collectionA11yInit = true;

  // The COLLECTIONS dropdown uses the same checkbox + label pattern as the sort dropdown.
  var SORT_BUTTON = '.sort-dropdown label.dropdown-button, .collections-dropdown label.dropdown-button';
  var FILTER_BUTTON = '.filter-button-label[role="button"]';

  function toggleFor(label) {
    return label.htmlFor ? document.getElementById(label.htmlFor) : null;
  }

  function syncSort() {
    document.querySelectorAll(SORT_BUTTON).forEach(function (label) {
      var box = toggleFor(label);
      var open = !!(box && box.checked);
      label.setAttribute('aria-expanded', open ? 'true' : 'false');
      // Another script closed the list while focus was on one of its options.
      var wrap = label.closest('.custom-dropdown');
      var list = !open && wrap && wrap.querySelector('.dropdown-list');
      if (list && list.contains(document.activeElement)) label.focus();
    });
  }

  function filterIsOpen() {
    var mobile = document.getElementById('mobile-filter-sidebar');
    var aside = document.querySelector('.vdb_gs_filters.diamond-filters');
    return !!(
      (mobile && mobile.classList.contains('is-open')) ||
      (aside && aside.classList.contains('is--open'))
    );
  }

  function syncFilter() {
    var open = filterIsOpen() ? 'true' : 'false';
    document.querySelectorAll(FILTER_BUTTON).forEach(function (button) {
      button.setAttribute('aria-expanded', open);
    });
  }

  document.addEventListener('keydown', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var isActivate = event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar';

    var sortLabel = target.closest(SORT_BUTTON);
    if (sortLabel && isActivate) {
      event.preventDefault();
      sortLabel.click();
      return;
    }

    var filterButton = target.closest(FILTER_BUTTON);
    if (filterButton && (event.key === ' ' || event.key === 'Spacebar')) {
      event.preventDefault();
      filterButton.click();
      return;
    }

    if (event.key === 'Escape' || event.key === 'Esc') {
      document.querySelectorAll(SORT_BUTTON).forEach(function (label) {
        var box = toggleFor(label);
        if (box && box.checked) {
          box.checked = false;
          if (label.closest('.custom-dropdown').contains(target)) label.focus();
        }
      });
      syncSort();
    }
  });

  // Other scripts uncheck the toggles programmatically, which fires no event,
  // so re-read the state after every click.
  document.addEventListener('click', function () {
    setTimeout(syncSort, 0);
  });

  function init() {
    // COLLECTIONS labels carry no role in the markup (the sort labels do).
    document.querySelectorAll('.collections-dropdown label.dropdown-button').forEach(function (label) {
      if (!label.hasAttribute('role')) label.setAttribute('role', 'button');
      if (!label.hasAttribute('tabindex')) label.setAttribute('tabindex', '0');
    });
    syncSort();
    syncFilter();

    ['mobile-filter-sidebar'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) new MutationObserver(syncFilter).observe(el, { attributes: true, attributeFilter: ['class'] });
    });
    var aside = document.querySelector('.vdb_gs_filters.diamond-filters');
    if (aside) new MutationObserver(syncFilter).observe(aside, { attributes: true, attributeFilter: ['class'] });

    // Results announcer
    var status = document.querySelector('[data-collection-results-status]');
    var titles = document.querySelectorAll('.collection-title');
    var grid = document.querySelector('.collection-matrix');
    if (!status || !(titles.length || grid)) return;

    var timer = null;
    function announce() {
      var countEl = document.querySelector('.collection-title .collection-count');
      var match = countEl && countEl.textContent.match(/\d[\d,.]*/);
      if (!match) return;
      var n = match[0];
      var plain = parseInt(n.replace(/[^\d]/g, ''), 10);
      var template = plain === 1 ? status.getAttribute('data-one') : status.getAttribute('data-other');
      if (!template) return;
      var message = template.replace('__N__', n);
      status.textContent = '';
      setTimeout(function () {
        status.textContent = message;
      }, 50);
    }

    var observer = new MutationObserver(function () {
      // sortProducts() unchecks the sort toggles in the same XHR callback that swaps the grid.
      syncSort();
      clearTimeout(timer);
      timer = setTimeout(announce, 300);
    });
    titles.forEach(function (title) {
      observer.observe(title, { childList: true, subtree: true });
    });
    // Sorting through window.sortProducts() swaps only the grid.
    if (grid) observer.observe(grid, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
